import React, { useMemo, useState } from 'react';
import { RepeatableFormModal } from './DynamicForm.repeatable.modal';
import { RepeatableFormTable } from './DynamicForm.repeatable.table';
import type {
  FormFieldValue,
  RepeatableAIContext,
  RepeatableBlock,
  RepeatableTemplate,
} from './DynamicForm.repeatable.utils';
import { blocksFromFormData, formDataUpdatesFromBlocks } from './DynamicForm.repeatable.utils';

export type RepeatableFormSectionProps = {
  template: RepeatableTemplate;
  formData: Record<string, unknown>;
  fieldErrors: Record<string, string>;
  canEdit: boolean;
  onFieldsChange: (updates: Record<string, FormFieldValue>) => void;
  aiContext: RepeatableAIContext;
};

export function RepeatableFormSection({
  template,
  formData,
  fieldErrors,
  canEdit,
  onFieldsChange,
  aiContext,
}: RepeatableFormSectionProps): React.JSX.Element {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const blocks = useMemo(() => blocksFromFormData(template, formData), [template, formData]);

  const handleSave = (updatedBlocks: RepeatableBlock[]): void => {
    onFieldsChange(formDataUpdatesFromBlocks(template, updatedBlocks));
    setIsModalOpen(false);
  };

  return (
    <>
      <RepeatableFormTable
        template={template}
        blocks={blocks}
        onEdit={canEdit ? () => setIsModalOpen(true) : undefined}
      />
      {canEdit && (
        <RepeatableFormModal
          open={isModalOpen}
          template={template}
          initialBlocks={blocks}
          fieldErrors={fieldErrors}
          onSave={handleSave}
          onCancel={() => setIsModalOpen(false)}
          aiContext={aiContext}
        />
      )}
    </>
  );
}
